<template>
<div>
    <bar-manut 
        single-entity="Tabela de Desconto" 
        plural-entity="Tabelas de Desconto" 
        :crud="this.crud" 
        :btn-delete="true"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>
    <div>
        <div class="default-container">
            
            <div class="row">                
                <form-field ref="descricao" v-model="tabdes.descricao" type="text" col="12"
                    case="upper" name="descricao" :v-errors="errors" :metadata="metadata.tabdes.descricao" v-validate="metadata.tabdes.descricao.validator"
                    label="Descrição"></form-field>
            </div>                
            <div class="row">
                <form-field v-model="tabdes.dtinicio" type="date" col="3" 
                        name="dtinicio" :v-errors="errors" label="Data de Início" :metadata="metadata.tabdes.dtinicio" v-validate="metadata.tabdes.dtinicio.validator"></form-field>
                <form-field v-model="tabdes.dttermino" type="date" col="3" 
                        name="dttermino" :v-errors="errors" label="Data de Término" :metadata="metadata.tabdes.dttermino" v-validate="metadata.tabdes.dttermino.validator"></form-field>                                                
            </div>                  
            <label-title title="Itens da Tabela de Desconto" class="nb-margin-bottom nb-margin-top"></label-title>
            <div class="row">
                <div class="col-md-12 col-12">
                    <div class="">
                        <varejo-add-item ref="item" v-model="coditem" :add-button="true" @onselect="handleNewItem" :exibePreco="false" tabelaPreco="1"></varejo-add-item>                        
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-12">                    
                    <div class="mainbox" v-for="(valor, index) in tabdesit" :key="index">                    
                        <div class="box">
                            <div class="row align-items-center">                                                        
                                <div class="col-md-1 col-1 text-center">
                                    <img v-if="valor.url" :src="valor.url" class="mx-auto d-block img-thumbnail" 
                                    alt="Logotipo" style="max-width: 45px; max-height: 45px; cursor: pointer;">
                                    <i v-if="!valor.url" class="fa fa-camera mx-auto d-block" style="font-size: 25px; color: silver"></i>
                                </div>
                                <div class="col-md-2 col-1">
                                    <v-label label="Código do Item"></v-label><br>
                                    <span class="lbl">{{ valor.codigo }}</span>
                                </div>
                                <div class="col-md-6 col-1">
                                    <v-label label="Item"></v-label><br>
                                    <span class="lbl">{{ valor.descricao }}</span>
                                </div>
                                <form-field ref="pdesc" v-model="valor.pdesc" type="value" col="2" :metadata="metadata.tabdesit.pdesc"
                                    addon="%"></form-field>
                                <!-- <div class="col-md-2 col-1">
                                    <v-label label="Desconto"></v-label><br>
                                </div> -->

                                <div class="col-md-1 col-2">
                                    <v-button label="" title="Excluir Item" icon="fa-trash" @click="handleDeleteVariavel(index)"></v-button>
                                </div>                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                                    
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'
import InputTypeahead from '../components/input-typeahead'
import VarejoAddItem from '../forms-varejo/varejo-add-item'

export default {
    props: {
        index: '',
        crud: '',
    },

    components: {
        InputTypeahead, VarejoAddItem
    },

    data() {
        return {
            crudText: '',
            tabdes: {...this.$store.getters.getEntities.tabdes},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
            tabdesit: [],
            coditem: '',
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    watch: {
    },

    methods: {
        closeForm () {
            this.$emit('closeform', this.tabdes.codtabdes)
        },

        handleSave () {
            //BOTAO SALVAR

            var valido = true;

            if (this.tabdes.dtinicio > this.tabdes.dttermino) {
                valido = false
                this.$erpToastError('A data de término não pode ser maior que a data de início')
            }

            if (valido) {
            this.$validator.validateAll().then(isValid => {
                //this.tabdes.dtinicio > this.tabdes.dttermino
                if (!isValid) {
                    this.$erpToastError('Corrija os erros de preenchimento para continuar!')
                } else {
                    this.apiPost()
                }
            })
            }
        },

        handleDelete () {
            this.apiDelete()
        },       

        handleDeleteVariavel (index) {            
            this.tabdesit.splice(index,1)
        },

        handleNewItem (selectedItem) {            
            console.log("salvar")

            // Verifica se foi selecionado algum item
            if (!selectedItem) return            

            // Verifica se o item já não foi adicionado
            if (this.tabdesit) {
            for(var i=0; i<this.tabdesit.length; i++) {
                if(this.tabdesit[i].coditem === selectedItem.coditem) {
                    return
                }
            }
            }

            var p = {
                coditem: selectedItem.coditem,
                codtabdes: '',
                codtabdesit: '',
                descricao: selectedItem.descricao
            }
            this.tabdesit.push(p)        
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadTabdes', { id: this.index } )
            if (this.$store.getters.getTabdes) {
                this.tabdes = {...this.$store.getters.getTabdes}                
                this.tabdesit = this.tabdes.tabdesit
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/tabdes/' + this.tabdes.codtabdes

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/tabdes/'
            this.tabdes.tabdesit = this.tabdesit
            var sendData = { tabdes: this.tabdes }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },

    },

    beforeCreate () {

    },

    created () {
        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
            this.tabdes.ativa = 'A'
            this.tabdes.dtinicio = this.$getDate()
        } else {
            this.loadData()  
        }

        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.descricao.focus()
        })

    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/tabdes-form.vue